import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAccessRights from 'packages/hooks/useAccessRights';
import useQueryParams from 'packages/hooks/useQueryParams';
import { setPage } from 'packages/store/newDesign/newDesign.actions';
import { getNewDesignPage } from 'packages/store/newDesign/newDesign.selectors';
import roles from 'packages/configs/roles';
import { DesignSubPages } from '../designCreateModal/components/Sidebar/types';
import DesignCreateModal from '../designCreateModal/DesignCreateModal';

const useNewDesignModal = () => {
    const dispatch = useDispatch();
    const { isAccountRoleAssigned } = useAccessRights();
    const [newDesignModal, setNewDesignModal] = useState(false);
    const [previousParams, setPreviousParams] = useState('');
    const { getQueryParam, resetQueryParams, getAllQueryParams, restoreQueryParams } = useQueryParams();
    const isModalUrlReady = getQueryParam('create') === 'true';

    const modalActivePage = useSelector(getNewDesignPage);

    const setNewDesignModalHandler = (value) => {
        if (isAccountRoleAssigned(roles.video_brand_studio.video.manage)) {
            dispatch(setPage(DesignSubPages.CATEGORIES));
        }

        setNewDesignModal(value);
    };

    const onClose = () => {
        setNewDesignModal(false);
        resetQueryParams([
            'ownership',
            'typeDesign',
            'typeTemplate',
            'sortedBy',
            'sortOrder',
            'view',
            'categoryId',
            'create',
            'page',
            'search',
        ]);
        restoreQueryParams(previousParams);
    };

    const renderNewDesignModal = () =>
        newDesignModal && isModalUrlReady && <DesignCreateModal isOpen={newDesignModal} onClose={onClose} />;

    // Filters of the host page must not leak into the modal, so the URL is rewritten in a single
    // navigation and the modal is mounted only after that (its pages read query params on mount).
    useLayoutEffect(() => {
        if (!newDesignModal) {
            return;
        }

        const query = new URLSearchParams(getAllQueryParams());

        if (query.size && query.get('create') !== 'true') {
            setPreviousParams(query.toString());
            ['ownership', 'typeDesign', 'sortedBy', 'sortOrder', 'view'].forEach((key) => query.delete(key));
        }

        query.set('create', 'true');
        query.set('page', modalActivePage.toLowerCase());
        restoreQueryParams(query.toString());
    }, [newDesignModal, modalActivePage]);

    return {
        setNewDesignModal: setNewDesignModalHandler,
        renderNewDesignModal,
    };
};

export default useNewDesignModal;
